import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';

export default function AmazonLoginPage() {
  return (
    <div>
      <ModalLoadingOverlay
        messages={['Recuperando dados de perfil da conta Amazon...']}
      />
    </div>
  );
}
